import { useSideNavOpen } from '@/store';
import { useEffect, useState } from 'react';

const useOpenCloseToggle = () => {
	const [open, setOpen] = useState(true);
	const toggleOpen = () => setOpen((prev) => !prev);
	const sideNavOpen = useSideNavOpen();

	// keep open when side nav is closed
	useEffect(() => {
		if (!sideNavOpen) {
			setOpen(true);
		}
	}, [sideNavOpen]);

	return { open, toggleOpen };
};

export default useOpenCloseToggle;
